<template lang="pug">
div
  slot(name="top")
  .v-data-table__wrapper
    div.preloader(v-if="loading")
      v-progress-linear(
        :indeterminate="true"
      )
      .preloader__item
    table
      slot(name="header" :headers="_headers" :props="headerProps" :on="on")

      slot(name="bottom")
        tbody
          template(v-for="group in groupedList")
            tr.group-row
              td 
                group-table-select(
                  v-slot="groupSelectProps"
                  :itemKey="itemKey"
                  :activeItems="activeItems"
                  :items="group.items"
                  @selected="$emit('input', $event)"
                  @unselected="$emit('input', $event)"
                )
                  v-checkbox(
                    :value="groupSelectProps.isSelected"
                    :key="group.label"
                    hide-details
                    @change="groupSelectProps.select"
                  ).mt-0
          
              td(:colspan="_headers.length - 1") {{ group.label }}
            template(v-for="(item, index) in group.items")
              expanded(v-slot="expanded" :key="item[itemKey]" :itemKey="itemKey" :expandedItems="expandedItems" :expand="expand" :index="index" :item="item")
                table-select(
                  v-slot="selectProps"
                  :itemKey="itemKey"
                  :activeItems="activeItems"
                  :index="index" 
                  :item="item"
                  @selected="selectItem"
                  @unselected="unselectItem"
                )
                  div.contents
                    slot(
                      name="item" 
                      :item="item" 
                      :isSelected="selectProps.isSelected"
                      :index="index" :expand="expanded.expand" :isExpanded="expanded.isExpanded" :select="selectProps.select")
                    tr(v-if="expanded.isExpanded")
                      slot(name="expanded-item" :headers="_headers" :item="item" :expand="expanded.expand" :isExpanded="expanded.isExpanded")
</template>

<script>
import Expanded from "@/components/global/TableExpand.vue"
import TableSelect from "@/components/global/table/TableSelect.vue"
import GroupTableSelect from "@/components/global/table/GroupTableSelect.vue"
import appCheckbox from "@/components/global/Checkbox.vue"

export default {
  props: {
    headers: Array,
    groupedList: null,
    value: Array,
    itemKey: {
      required: true
    },
    loading: Boolean
  },

  data: () => ({
    expanded: false,
    expandedItems: {},
    activeItems: {},
  }),

  mounted() {
  },
  computed: {
    items() {
      if(!this.groupedList) return []
      let formattedGroupList = Object.values(this.groupedList)
      if(!formattedGroupList.length) return []
      return formattedGroupList.reduce((a, b)=> {
        return [...a, ...b.items]
      }, [])
    },
    everyItem() {
      if(!this.items.length) return false
      return this.value.length === this.items.length
    },
    headerProps() {
      return {
        everyItem: this.everyItem,
        headers: this._headers,
        options: {
          sortBy: [],
          sortDesc: []
        }
      }
    },

    _headers() {
      let selectHeader ={text: '', sortabe: false, value: 'data-table-select'}
      let headers = this.headers.map(item => item)
      headers.unshift(selectHeader)
      return headers
    },

    on() {
      return {
        ['toggle-select-all']: this.toggleSelectAll
      }
    }
  },

  methods: {
    expand(key, item) {
      if(key in this.expandedItems) {
        this.hideExpandedItem(key)
        return
      }
      if(Object.keys(this.expandedItems).length) this.hideExpandedItem(Object.keys(this.expandedItems)[0])
      this.$set(this.expandedItems, key, item)
    },

    hideExpandedItem(key) {
      this.$delete(this.expandedItems, key)
    },

    _isExpanded(index) {
      if(index in this.expandedItems) return true
      return false
    },
    toggleSelectAll(val) {
      if(!val) return this.$emit('input', [])
      this.$emit('input', this.items)
    },
    selectItem(item) {
      this.$emit('input', [...this.value, item])
    },

    unselectItem(item) {
      let unselectedItemIndex = this.value.findIndex(activeItem => activeItem[this.itemKey] === item[this.itemKey])
      if(unselectedItemIndex < 0) return
      let activeItems = [...this.value]
      activeItems.splice(unselectedItemIndex, 1)
      this.$emit('input', activeItems)
    }
  },

  watch: {
    value() {
      for(let field in this.activeItems) {
        if(!this.value.length) {
          this.$delete(this.activeItems, field)
          continue
        }
        let item = this.value.find(item => item[this.itemKey] === field)
        if(!item) this.$delete(this.activeItems, field)
      }
      this.value.forEach((item, index) => {
        let key = this.itemKey ? item[this.itemKey] : index
        if(key in item) return
        this.$set(this.activeItems, key, item)
      })
    }
  },

  components: {
    expanded: Expanded,
    tableSelect: TableSelect,
    groupTableSelect: GroupTableSelect,
    appCheckbox: appCheckbox
    // TableItem: TableItem
  }
}
</script>

<style lang="scss" scoped>
.group-row {
  background-color: $primary-color !important;
  color: #fff;
  &:hover {
    background-color: $primary-color;
    & td {
      background-color: $primary-color;
    }
  }
}
.preloader {
  height: 4px;
}

</style>

<style lang="scss">
.group-row { 
  .v-input--checkbox .v-icon {
    color: #fff;
  }
}

.contents {
  display: contents;
  vertical-align: middle;
}

.contents:nth-child(2n) tr {
  background: #f1f2f6;
}
</style>